import { Badge } from '@fluentui/react-components';
import { ClientStatus, OfferStatus, OrderStatus, SubscriptionStatus, UserRole } from '../../models/enums';

const resolveStatus = (value: number): { label: string; color: 'success' | 'warning' | 'danger' | 'brand' | 'informative' } => {
  switch (value) {
    case ClientStatus.Actif:
    case SubscriptionStatus.Active:
    case OfferStatus.Envoyee:
    case OfferStatus.Acceptee:
    case OrderStatus.Completed:
      return { label: 'Active', color: 'success' };
    case ClientStatus.Suspendu:
    case SubscriptionStatus.Suspended:
    case OrderStatus.Pending:
    case OrderStatus.Suspended:
    case OfferStatus.Expiree:
      return { label: 'Attention', color: 'warning' };
    case ClientStatus.Inactif:
    case OrderStatus.Cancelled:
    case OrderStatus.Failed:
    case SubscriptionStatus.Expired:
    case SubscriptionStatus.Deleted:
    case OfferStatus.Refusee:
      return { label: 'Closed', color: 'danger' };
    case ClientStatus.EnPeriodeTrial:
    case SubscriptionStatus.PendingCancel:
    case OfferStatus.Brouillon:
    case OfferStatus.EnValidation:
    case UserRole.Admin:
    case UserRole.Commercial:
    case UserRole.Manager:
      return { label: 'In progress', color: 'brand' };
    default:
      return { label: 'Unknown', color: 'informative' };
  }
};

export const StatusBadge = ({ value }: { value: number }) => {
  const entry = resolveStatus(value);
  return <Badge color={entry.color}>{entry.label}</Badge>;
};
